import LxcError from "~/core/models/LxcError.class";
import operationManagerService from "~/core/services/operationManager.service";
import type { DtwinCreateOperation } from "~/modules/dtwin/models/DtwinCreateOperation.interface";

export function useCreateOperationConfiguration({
  organizationCode,
}: {
  organizationCode?: number;
}) {
  const isLoading = ref(false);
  const error: Ref<LxcError | undefined> = ref();

  async function createOperation(operation: DtwinCreateOperation) {
    if (!organizationCode) {
      throw new Error("Organization code is undefined");
    }

    isLoading.value = true;
    error.value = undefined;

    const response = await operationManagerService.createOperation(
      organizationCode,
      operation,
    );

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    createOperation,
    isLoading,
    error,
  };
}
